<script >
export default {
  props: ['value','listType', 'showFileList'],
  data() {
    return {
      item: {
        type: 'image',
        fileList: []
      }
    }
  },
  watch: {
    value: {
      handler: function(v) {
        if (v) this.item.fileList = [{ url: v, response: { url: v }}]
        else this.item.fileList = []
      },
      immediate: true
    }
  },
  methods: {
    onSuccess(item, { response, file, fileList }) {
      console.log('onsuccess', item)
      if (response) response.url = (process.env.NODE_ENV === 'development' ? '' : '') + response.url
      item.fileList = fileList
      this.$emit('input', response.url)
    },
    onRemove(item, { file, fileList }) {
      item.fileList = fileList
      this.$emit('input', '')
    },
    onPreview(item, e) {
      if (item.type === 'file') {
        window.open(e.file.url)
      } else if (item.type === 'image' || item.type === 'images') {
        window.open(e.file.url) // 暂时直接新窗口查看
      }
    },
    beforeUpload(item, {file}){
      // // 只能上传1个文件，上传前删除原来的，否则 不触发上传
      // this.item.fileList = []
    }
  }
}
</script>

<template>
  <el-upload
    action="/user/upfiles/upload"
    :headers="{'X-Requested-With': 'XMLHttpRequest'}"
    :limit="1"
    :list-type="listType || 'picture-card'"
    :show-file-list="showFileList"
    :file-list="item.fileList"
    :with-credentials="true"
    :class="{'hide': item.fileList.length>=1}"
    :on-success="(response, file, fileList)	=>onSuccess(item,{response, file, fileList})"
    :on-remove="(file, fileList)	=>onRemove(item,{file, fileList})"
    :on-preview="(file) => onPreview(item, {file})"
    :before-upload="(file) => beforeUpload(item, {file})"
  >
    <slot >
      <i slot="default" class="el-icon-plus" />
    </slot>
  </el-upload>
</template>

<style scoped>
/deep/ .hide .el-upload--picture-card {
  display: none;
}
/*el-element 上传文件会有跳动的效果。加上上述代码可以去掉该动效*/
::v-deep  .el-upload-list__item{
  transition:none !important;
  -webkit-transition:nonne !important;
}
::v-deep   .el-upload-list__item-name{
  transition:none !important;
  -webkit-transition:nonne !important;
}

::v-deep .el-upload input{
    display: none;
}
</style>
